import type { CSSProperties } from 'react';

/**
 * THE app brand gradient (Figma `theme`: #009AC8 13.39% → #1BB980 86.63% at 246.81°), in token form
 * so it flips with the theme. `--brand-dark` IS #009AC8 (canonical since 2026-07-18) and `--gain` is
 * #1BB980, so the token form and the Figma hex render identically — never hardcode the hex again.
 *
 * Every gradient CTA / accent in the app imports this const (previously ~18 duplicated literals).
 * The SVG assets (logo.svg, login-panel.svg, favicon.svg) keep their own hardcoded stops.
 */
export const BRAND_GRADIENT = 'linear-gradient(246.81deg, var(--brand-dark) 13.39%, var(--gain) 86.63%)';

/**
 * Gradient TEXT (background-clip) — the Figma "Button text" treatment used by Link/Unlink buttons,
 * the connect dialogs' secondary buttons, etc. Spread into a `style` prop.
 */
export const gradientTextStyle: CSSProperties = {
  background: BRAND_GRADIENT,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  color: 'transparent',
};
